/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import * as Icon from "react-feather";
import { MdOutlinePersonSearch } from "react-icons/md";
import { Link, NavLink } from "react-router-dom";
import { removeLocalStorageAdmin } from "../../../utils/Functions/removeLocalStorageAdmin";
import baseUrl from "../../../utils/baseUrl";
import {
  Accounts_Audit_roles,
  Accounts_DHEU_Audit_roles,
  DHEU_Accounts_roles,
  DHEU_Audit_roles,
} from "../../../utils/variables/rolesList";
import InternetStatus from "../InternetStatus";

const Navbar = (props) => {
  // State to manage which menu items are expanded — restore from sessionStorage so
  // the expanded menu remains open after navigation.
  const [expandedMenus, setExpandedMenus] = React.useState(() => {
    try {
      const raw = sessionStorage.getItem("sidebarExpandedMenus");
      return raw ? JSON.parse(raw) : {};
    } catch (err) {
      return {};
    }
  });

  // Toggle menu expansion and persist to sessionStorage.
  // Close other top-level menus when a new one is selected (accordion behavior for main menus).
  // Allow nested submenus to expand independently.
  const toggleMenu = (menuKey) => {
    setExpandedMenus((prev) => {
      const isOpen = !!prev[menuKey];

      // List of top-level menu keys that should be mutually exclusive
      const topLevelMenus = [
        "orders",
        "parcel",
        "shipping",
        "accounts",
        "purchaseOrder",
        "paymentAdvice",
        "inventory",
        "orderBill",
        "reports",
        "paymentMethod",
        "commission",
        "campaigns",
        "festivals",
        "sizeCharts",
        "outlets",
        "blogs",
        "videoJournal",
        "contents",
        "stores",
        "warranty",
        "adsBanner",
        "administrative",
        "settings",
      ];

      // Check if this is a top-level menu or a nested submenu
      const isTopLevelMenu = topLevelMenus.includes(menuKey);

      if (isTopLevelMenu) {
        // For top-level menus, close all other top-level menus but keep nested menus open
        const next = isOpen
          ? {}
          : topLevelMenus.reduce((acc, key) => {
              acc[key] = key === menuKey;
              return acc;
            }, {});
        try {
          sessionStorage.setItem("sidebarExpandedMenus", JSON.stringify(next));
        } catch (err) {
          // ignore storage errors
        }
        return next;
      } else {
        // For nested menus, just toggle without affecting other menus
        const next = isOpen
          ? { ...prev, [menuKey]: false }
          : { ...prev, [menuKey]: true };
        try {
          sessionStorage.setItem("sidebarExpandedMenus", JSON.stringify(next));
        } catch (err) {
          // ignore storage errors
        }
        return next;
      }
    });
  };

  // Keep sessionStorage in sync if some other code modifies expandedMenus
  React.useEffect(() => {
    try {
      sessionStorage.setItem(
        "sidebarExpandedMenus",
        JSON.stringify(expandedMenus),
      );
    } catch (err) {
      // ignore
    }
  }, [expandedMenus]);

  return (
    <aside className="sidebar" style={{ overflow: "visible" }}>
      <div className="scroll-sidebar" style={{ overflow: "hidden" }}>
        {props.profileById.map((profile) => (
          <div className="user-profile" key={profile.adminId}>
            <div className="dropdown user-pro-body">
              <div className="profile-image">
                <img
                  src={baseUrl.concat(profile.adminImageUrl)}
                  alt="user-img"
                  className="img-circle"
                />
                <Link
                  to="#!"
                  className="dropdown-toggle u-dropdown text-blue"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="badge badge-danger">
                    <i className="fa fa-angle-down"></i>
                  </span>
                </Link>
                <ul className="dropdown-menu animated flipInY">
                  <li>
                    <NavLink to="/Profile">
                      <i className="fa fa-user"></i> Profile
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={`/EditProfile/${profile.adminId}`}>
                      <i className="fa fa-cog"></i> Settings
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/Login"
                      onClick={() => removeLocalStorageAdmin()}
                    >
                      <i className="fa fa-power-off"></i> Logout
                    </NavLink>
                  </li>
                </ul>
              </div>
              <p className="profile-text m-t-15 font-16">
                <Link to="/Profile" style={{ textTransform: "capitalize" }}>
                  {profile.adminName}
                </Link>
                <InternetStatus />
              </p>
              <p className="profile-text m-t-5 font-13">
                {profile?.designation}
              </p>
            </div>
          </div>
        ))}

        <nav className="sidebar-nav">
          <ul id="side-menu">
            {/* Admin, DHEU Admin and Accounts */}
            <li>
              <NavLink to="/Home" aria-expanded="false">
                <Icon.Monitor className="text-dark fa-fw" />{" "}
                <span className="hide-menu"> Dashboard </span>
              </NavLink>
            </li>

            {/* DHEU Admin */}
            {props?.profileById[0]?.designationId === 9 && (
              <li>
                <NavLink to="/CreateProductDHEU" aria-expanded="false">
                  <Icon.HardDrive className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Products</span>
                </NavLink>
              </li>
            )}

            {props?.profileById[0]?.designationId === 9 && (
              <li>
                <NavLink to="/CreateOrderDHEU" aria-expanded="false">
                  <Icon.ShoppingCart className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Create Order</span>
                </NavLink>
              </li>
            )}

            {props?.profileById[0]?.designationId === 9 && (
              <li>
                <NavLink to="/CreateDHEUBlog" aria-expanded="false">
                  <Icon.Edit2 className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> DHEU Blogs</span>
                </NavLink>
              </li>
            )}

            {props?.profileById[0]?.designationId === 9 && (
              <li>
                <NavLink to="/DHEUStoreBannerList" aria-expanded="false">
                  <Icon.Package className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> DHEU Store</span>
                </NavLink>
              </li>
            )}

            {/* Admin */}
            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <NavLink to="/CreateProductAdmin" aria-expanded="false">
                  <Icon.HardDrive className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Products</span>
                </NavLink>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("orders");
                  }}
                  aria-expanded={expandedMenus.orders || false}
                >
                  <Icon.ShoppingCart className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Orders </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.orders || false}
                  className={`collapse ${expandedMenus.orders ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateOrder">Create Order</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/ManageOrdersAdmin?status=order_placed"}>
                      Manage Orders
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={"/CancelOrders?status=cancel_request"}>
                      Cancel Orders
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={"/ReturnOrders?status=return_request"}>
                      Return Orders
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("parcel");
                  }}
                  aria-expanded={expandedMenus.parcel || false}
                >
                  <Icon.Archive className="text-dark fa-fw" />
                  <span className="hide-menu"> Parcel Delivery </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.parcel || false}
                  className={`collapse ${expandedMenus.parcel ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/Parcel-DeliveryList">Delivery List</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("shipping");
                  }}
                  aria-expanded={expandedMenus.shipping || false}
                >
                  <Icon.Truck className="text-dark fa-fw" />
                  <span className="hide-menu"> Shipping </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.shipping || false}
                  className={`collapse ${expandedMenus.shipping ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateCourierProfile">
                      Courier Profile
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateShippingType"> Shipping Type</NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateShippingOptions">
                      {" "}
                      Shipping Option
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateCourierProductType">
                      {" "}
                      Courier Product Type
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/CreateShippingCost"> Shipping Cost</NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateCourierCost"> Courier Cost</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Accounts */}
            {Accounts_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <NavLink to="/OrdersAccounts" aria-expanded="false">
                  <Icon.ShoppingCart className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Orders</span>
                </NavLink>
              </li>
            )}

            {props?.profileById[0]?.designationId === 2 && (
              <li>
                <NavLink
                  to="/Seller-Verification?verificationStatus=Pending"
                  aria-expanded="false"
                >
                  <Icon.CheckCircle className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Seller Documents </span>
                </NavLink>
              </li>
            )}

            {/* Except Audit and DHEU */}
            {![9].includes(props?.profileById?.[0]?.designationId) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("accounts");
                  }}
                  aria-expanded={expandedMenus.accounts || false}
                >
                  {[11].includes(props?.profileById?.[0]?.designationId) ? (
                    <>
                      <Icon.Printer className="text-dark fa-fw" />{" "}
                      <span className="hide-menu"> Reports </span>
                    </>
                  ) : (
                    <>
                      <Icon.Book className="text-dark fa-fw" />{" "}
                      <span className="hide-menu"> Accounts </span>
                    </>
                  )}
                </a>
                <ul
                  aria-expanded={expandedMenus.accounts || false}
                  className={`collapse ${expandedMenus.accounts ? "in" : ""}`}
                >
                  {!DHEU_Audit_roles.includes(
                    props?.profileById?.[0]?.designationId,
                  ) && (
                    <li>
                      <NavLink to="/Accounts?type=transaction_history">
                        {" "}
                        Transaction History
                      </NavLink>
                    </li>
                  )}
                  {!DHEU_Audit_roles.includes(
                    props?.profileById?.[0]?.designationId,
                  ) &&
                    props?.profileById[0]?.designationId !== 2 && (
                      <li>
                        <NavLink to="/Accounts?type=customer_order_payment">
                          Customer Order Payment
                        </NavLink>
                      </li>
                    )}
                  <li>
                    <NavLink to="/Accounts?type=sales_report">
                      {" "}
                      Sales Report
                    </NavLink>
                  </li>
                  {props?.profileById[0]?.designationId === 11 && (
                    <li>
                      <NavLink to="/PaymentAdviceReport">
                        Payment Advice Report
                      </NavLink>
                    </li>
                  )}
                  {props?.profileById[0]?.designationId === 11 && (
                    <li>
                      <NavLink to="/CategoryWiseReportAudit">
                        Category Wise Report
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {/* Audit */}
            {props?.profileById[0]?.designationId === 11 && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("purchaseOrder");
                  }}
                  aria-expanded={expandedMenus.purchaseOrder || false}
                >
                  <Icon.Clipboard className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Purchase Order </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.purchaseOrder || false}
                  className={`collapse ${
                    expandedMenus.purchaseOrder ? "in" : ""
                  }`}
                >
                  <li>
                    <NavLink to="/ReceivedPurchaseOrderList?page=1">
                      Received P.O. List
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/ReturnPOList?page=1">
                      Return P.O. List
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Admin */}
            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("purchaseOrder");
                  }}
                  aria-expanded={expandedMenus.purchaseOrder || false}
                >
                  <Icon.Clipboard className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Purchase Order </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.purchaseOrder || false}
                  className={`collapse ${
                    expandedMenus.purchaseOrder ? "in" : ""
                  }`}
                >
                  <li>
                    <NavLink to="/CreatePurchaseOrder">
                      Invoice-wise P.O.
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateGeneralPurchaseOrder">
                      General P.O.
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateStoreLocation">Store Location</NavLink>
                  </li>

                  <li>
                    <NavLink to="/CreatePurchaseOrderReceived">
                      P.O. Received
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/PurchaseOrderReceivedApprovalList">
                      Received P.O. Approval
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/CreateReturnPO">Return P.O.</NavLink>
                  </li>
                  <li>
                    <NavLink to="/ReturnPOApprovalList">
                      Return P.O. Approval
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {props?.profileById[0]?.designationId !== 9 && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("paymentAdvice");
                  }}
                  aria-expanded={expandedMenus.paymentAdvice || false}
                >
                  <Icon.Clipboard className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Payment Advice </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.paymentAdvice || false}
                  className={`collapse ${
                    expandedMenus.paymentAdvice ? "in" : ""
                  }`}
                >
                  {[3].includes(props?.profileById?.[0]?.designationId) && (
                    <li>
                      <NavLink to="/CreatePaymentAdvice">
                        Create Payment Advice
                      </NavLink>
                    </li>
                  )}

                  {props?.profileById[0]?.designationId !== 9 && (
                    <li>
                      <NavLink to="/PaymentAdviceList">
                        Payment Advice List
                      </NavLink>
                    </li>
                  )}

                  <li>
                    <NavLink to="/PaymentAdviceApprovalList">
                      Payment Advice Approval
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("inventory");
                  }}
                  aria-expanded={expandedMenus.inventory || false}
                >
                  <Icon.Box className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Inventory </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.inventory || false}
                  className={`collapse ${expandedMenus.inventory ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/StockReport">Stock Report</NavLink>
                  </li>
                  <li>
                    <NavLink to="/GenerateBarcode">Generate Barcode</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!DHEU_Accounts_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("orderBill");
                  }}
                  aria-expanded={expandedMenus.orderBill || false}
                >
                  <Icon.CheckSquare className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Order Bill </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.orderBill || false}
                  className={`collapse ${expandedMenus.orderBill ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/BillList">Bill List</NavLink>
                  </li>
                  {!Accounts_DHEU_Audit_roles.includes(
                    props?.profileById?.[0]?.designationId,
                  ) && (
                    <li>
                      <NavLink to="/PreviousReturnBillList">
                        Prev. Return Bill Create
                      </NavLink>
                    </li>
                  )}

                  <li>
                    <NavLink to="/ReturnBillList">Return Bill List</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("reports");
                  }}
                  aria-expanded={expandedMenus.reports || false}
                >
                  <Icon.Printer className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Reports </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.reports || false}
                  className={`collapse ${expandedMenus.reports ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/Report?type=order"> Order History</NavLink>
                  </li>
                  <li>
                    <NavLink to="/PO-Report"> P.O. Report</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("paymentMethod");
                  }}
                  aria-expanded={expandedMenus.paymentMethod || false}
                >
                  <Icon.DollarSign className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Payment Method </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.paymentMethod || false}
                  className={`collapse ${
                    expandedMenus.paymentMethod ? "in" : ""
                  }`}
                >
                  <li>
                    <NavLink to="/CreatePaymentMethod">
                      {" "}
                      Payment Method Create{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/PaymentMethodList">
                      {" "}
                      Payment Method List{" "}
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("campaigns");
                  }}
                  aria-expanded={expandedMenus.campaigns || false}
                >
                  <Icon.Percent className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Campaigns </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.campaigns || false}
                  className={`collapse ${expandedMenus.campaigns ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateCampaignType">Campaign Type</NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateCampaign">Campaign Create</NavLink>
                  </li>
                  <li>
                    <NavLink to="/CampaignList?status=active">
                      Campaigns List
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("festivals");
                  }}
                  aria-expanded={expandedMenus.festivals || false}
                >
                  <Icon.Clipboard className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Festivals </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.festivals || false}
                  className={`collapse ${expandedMenus.festivals ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateFestive">Festival Create</NavLink>
                  </li>
                  <li>
                    <NavLink to="/FestiveList?status=active">
                      Festivals List
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Admin and DHEU Admin Both*/}
            {!Accounts_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("sizeCharts");
                  }}
                  aria-expanded={expandedMenus.sizeCharts || false}
                >
                  <Icon.Crop className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Size Charts </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.sizeCharts || false}
                  className={`collapse ${expandedMenus.sizeCharts ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/Size-Chart-Attribute"> Attributes</NavLink>
                  </li>
                  <li>
                    <NavLink to="/Size-Guide-Measurement">Size Guide</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("outlets");
                  }}
                  aria-expanded={expandedMenus.outlets || false}
                >
                  <Icon.Map className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Outlets </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.outlets || false}
                  className={`collapse ${expandedMenus.outlets ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateOutlet">Create Outlet</NavLink>
                  </li>
                  <li>
                    <NavLink to="/OutletList">Outlets List</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Admin */}
            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("blogs");
                  }}
                  aria-expanded={expandedMenus.blogs || false}
                >
                  <Icon.Edit2 className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Blogs </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.blogs || false}
                  className={`collapse ${expandedMenus.blogs ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateBlogCategory"> Blog Category </NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateBlogPost"> Blog Post </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("videoJournal");
                  }}
                  aria-expanded={expandedMenus.videoJournal || false}
                >
                  <Icon.Youtube className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Media </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.videoJournal || false}
                  className={`collapse ${expandedMenus.videoJournal ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateJournalCategory">
                      {" "}
                      Media Category{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateJournalPost"> Media Post </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("contents");
                  }}
                  aria-expanded={expandedMenus.contents || false}
                >
                  <Icon.FileText className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Contents </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.contents || false}
                  className={`collapse ${expandedMenus.contents ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/Content-Type"> Content Type </NavLink>
                  </li>
                  <li>
                    <NavLink to="/Content-Post?type=create">
                      {" "}
                      Content Post{" "}
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("stores");
                  }}
                  aria-expanded={expandedMenus.stores || false}
                >
                  <Icon.Package className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Stores </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.stores || false}
                  className={`collapse ${expandedMenus.stores ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateAdminStoreBanner">
                      {" "}
                      Store Banner Create
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/AllStoreBannerList">
                      {" "}
                      Store Banner List
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("warranty");
                  }}
                  aria-expanded={expandedMenus.warranty || false}
                >
                  <Icon.CheckCircle className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Warranty Policy </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.warranty || false}
                  className={`collapse ${expandedMenus.warranty ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/WarrantyType">Warranty Type</NavLink>
                  </li>
                  <li>
                    <NavLink to="/WarrantyPeriod">Warranty Period</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <NavLink to="/Career" aria-expanded="false">
                  <MdOutlinePersonSearch
                    className="text-dark fa-fw"
                    style={{ fontSize: "20px !important" }}
                  />
                  <span className="hide-menu"> Career </span>
                </NavLink>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("adsBanner");
                  }}
                  aria-expanded={expandedMenus.adsBanner || false}
                >
                  <Icon.Tv className="text-dark fa-fw" />
                  <span className="hide-menu"> Ads & Banner </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.adsBanner || false}
                  className={`collapse ${expandedMenus.adsBanner ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateADBannerType">
                      Ads & Banner Type
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateImageLocation">Image Location</NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateImageType">Image Type</NavLink>
                  </li>

                  <li>
                    <NavLink to="/Create-ADBanner">Create Ads & Banner</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* {props?.profileById[0]?.designationId !== 2 && props?.profileById[0]?.designationId !== 9 && (
                <li>
                  <a
                    className="waves-effect"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    aria-expanded="false"
                  >
                    <Icon.Search className="text-dark fa-fw" />{" "}
                    <span className="hide-menu"> Search Suggestion </span>
                  </a>
                  <ul aria-expanded="false" className="collapse">

                    <li>
                      <NavLink to="/CreateSearchSuggestion">
                        Search Keyword Create
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/SearchSuggestionsList">
                        Search Suggestion List
                      </NavLink>
                    </li>
                  </ul>
                </li>
              )} */}
            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("administrative");
                  }}
                  aria-expanded={expandedMenus.administrative || false}
                >
                  <Icon.Shield className="text-dark fa-fw" />
                  <span className="hide-menu"> Administrative </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.administrative || false}
                  className={`collapse ${
                    expandedMenus.administrative ? "in" : ""
                  }`}
                >
                  <li>
                    <NavLink to="/CachingList"> Caching</NavLink>
                  </li>
                  <li>
                    <NavLink to="/CreateAppRelease"> App Release</NavLink>
                  </li>
                  <li>
                    <NavLink to="/ISRCaching"> ISR Caching</NavLink>
                  </li>
                </ul>
              </li>
            )}

            {!Accounts_DHEU_Audit_roles.includes(
              props?.profileById?.[0]?.designationId,
            ) && (
              <li>
                <a
                  className="waves-effect"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("settings");
                  }}
                  aria-expanded={expandedMenus.settings || false}
                >
                  <Icon.Settings className="text-dark fa-fw" />{" "}
                  <span className="hide-menu"> Settings </span>
                </a>
                <ul
                  aria-expanded={expandedMenus.settings || false}
                  className={`collapse ${expandedMenus.settings ? "in" : ""}`}
                >
                  <li>
                    <NavLink to="/CreateNewAdmin"> Admin</NavLink>
                  </li>

                  <li>
                    <NavLink to="/PendingSeller">Sellers</NavLink>
                  </li>

                  <li>
                    <NavLink to="/CreateProject"> Project </NavLink>
                  </li>

                  <li>
                    <NavLink to="/CreateInventory">Inventory </NavLink>
                  </li>

                  <li>
                    <NavLink to="/CreateBrand">Brands </NavLink>
                  </li>

                  <li>
                    <a
                      className="waves-effect"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleMenu("settingsCategory");
                      }}
                      aria-expanded={expandedMenus.settingsCategory || false}
                      style={{ cursor: "pointer" }}
                    >
                      <span className="hide-menu">Category</span>
                    </a>
                    <ul
                      aria-expanded={expandedMenus.settingsCategory || false}
                      className={`collapse ${
                        expandedMenus.settingsCategory ? "in" : ""
                      }`}
                    >
                      <li>
                        <NavLink to="/CreateCategory">Category Setup</NavLink>
                      </li>
                      <li>
                        <NavLink to="/CreateTopCategory">Top Category</NavLink>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <a
                      className="waves-effect"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleMenu("settingsVariants");
                      }}
                      aria-expanded={expandedMenus.settingsVariants || false}
                    >
                      <span className="hide-menu"> Variants </span>
                    </a>
                    <ul
                      aria-expanded={expandedMenus.settingsVariants || false}
                      className={`collapse ${
                        expandedMenus.settingsVariants ? "in" : ""
                      }`}
                    >
                      <li>
                        <NavLink to="/CreateProductVariant">
                          {" "}
                          Product Variant{" "}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/CreateProductVariantOptionValue">
                          {" "}
                          Product Variant Option Value
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/CreateProductVariantOption">
                          {" "}
                          Product Variant Option{" "}
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <a
                      className="waves-effect"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleMenu("settingsAddress");
                      }}
                      aria-expanded={expandedMenus.settingsAddress || false}
                    >
                      <span className="hide-menu">Address</span>
                    </a>
                    <ul
                      aria-expanded={expandedMenus.settingsAddress || false}
                      className={`collapse ${
                        expandedMenus.settingsAddress ? "in" : ""
                      }`}
                    >
                      <li>
                        <NavLink to="/AllCountryList">Country</NavLink>
                      </li>
                      <li>
                        <NavLink to="/CreateCity">District/City</NavLink>
                      </li>
                      <li>
                        <NavLink to="/CreateArea">Area/Thana/Upazila</NavLink>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <a
                      className="waves-effect"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleMenu("settingsDiscount");
                      }}
                      aria-expanded={expandedMenus.settingsDiscount || false}
                    >
                      <span className="hide-menu"> Discount </span>
                    </a>
                    <ul
                      aria-expanded={expandedMenus.settingsDiscount || false}
                      className={`collapse ${
                        expandedMenus.settingsDiscount ? "in" : ""
                      }`}
                    >
                      <li>
                        <NavLink to="/CreateDiscountType">
                          {" "}
                          Discount Type
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/CreateDiscountSummary">
                          {" "}
                          Discount Summary{" "}
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <NavLink to="/CreateVoucher">Vouchers</NavLink>
                  </li>

                  <li>
                    <NavLink to="/CommissionType">Commission Type </NavLink>
                  </li>

                  <li>
                    <NavLink to="/CreateOrderType">Orders Type </NavLink>
                  </li>

                  <li>
                    <NavLink to="/ImportCurrency">Import Currency </NavLink>
                  </li>
                </ul>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Navbar;
